import { useEffect, useRef } from 'react';

export default function Cursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;
    let rx = 0, ry = 0, raf;
    const onMove = (e) => {
      dot.style.left = e.clientX + 'px';
      dot.style.top = e.clientY + 'px';
      rx = e.clientX; ry = e.clientY;
    };
    const tick = () => {
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      raf = requestAnimationFrame(tick);
    };
    document.addEventListener('mousemove', onMove);
    raf = requestAnimationFrame(tick);
    return () => { document.removeEventListener('mousemove', onMove); cancelAnimationFrame(raf); };
  }, []);

  return (
    <>
      <div ref={dotRef} style={{
        width: 12, height: 12, background: '#00e5ff', borderRadius: '50%',
        position: 'fixed', top: 0, left: 0, pointerEvents: 'none', zIndex: 9999,
        transform: 'translate(-50%,-50%)', mixBlendMode: 'screen',
      }} />
      <div ref={ringRef} style={{
        width: 36, height: 36, border: '1px solid rgba(0,229,255,0.35)',
        borderRadius: '50%', position: 'fixed', top: 0, left: 0,
        pointerEvents: 'none', zIndex: 9998,
        transform: 'translate(-50%,-50%)',
        transition: 'transform 0.12s ease',
      }} />
    </>
  );
}
